/*
    ConfigState.js - App configuration
 */
export default class ConfigState {
    saveState = false
}
